import ReduxProtectedRoutes from './redux-protected-routes';

export default ReduxProtectedRoutes;